import urlHostName from './host-name';

type T = () => string | undefined;

const f: T = () => {
    const parts = urlHostName().split('.');

    return parts.includes('applearn') && parts[1] !== 'applearn' ? parts[0] : undefined;
};

export default f;
